export const BAR_HEIGHT = 70;
export const HEADER_HEIGHT = 64;
export const MOBILE_VIEW_BREAKPOINT = 1200;
export const LEFT_BAR_WIDTH = 170;
